import type { InputType } from 'config'
import { accountTypes } from 'config/user.type.constants'

export const broadCastAccountTypes = (): Record<string, any> => ({ ...accountTypes, borrower: 'Borrower' })

export const defaultInputs = (): Record<string, InputType> => {
  return {
    accountType: {
      inputType: 'multiselect',
      title: 'Account Type',
      options: broadCastAccountTypes(),
      required: true,
      value: {},
      sort: true,
    },
    title: {
      inputType: 'text',
      type: 'text',
      title: 'Title',
      value: '',
      required: true,
    },
    content: {
      inputType: 'textarea',
      title: 'Content',
      value: '',
      required: true,
    },
    file: {
      inputType: 'file',
      title: 'File',
      required: false,
    },
  }
}
